import { Box, Grid, useTheme } from "@mui/material";
import type { FC } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddItemCategoryTile } from "web_myplann/Portfolio/Components/PortfolioAddItemCategoryTile";
import type {
	PortfolioAddItemConfig,
	PortfolioAddItemId,
} from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";

type Props = {
	items: PortfolioAddItemConfig[];
	onItemClick: (id: PortfolioAddItemId) => void;
};

export const PortfolioAddItemCategoryList: FC<Props> = ({
	items,
	onItemClick,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Box
			bgcolor="background.paper"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
		>
			<Grid container spacing={theme.spacingTokens.sm}>
				{items.map((item) => (
					<Grid key={item.id} size={6}>
						<PortfolioAddItemCategoryTile
							icon={item.icon}
							label={t(item.labelKey)}
							color={item.color}
							onClick={() => onItemClick(item.id)}
						/>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};
